import { Routes, RouterModule } from "@angular/router";

import { DynamicReportComponent, AttendanceViewComponent } from "./index";
import { AuthguardService } from "../master/services";

export const DynamicReportRoutes: Routes = [
	{
		path: "",
		redirectTo: "/dynamicreport/attendanceview",
		pathMatch: "full",
	},
	{
		path: "attendanceview",
		data: { title: "Admin Attendance View" },
		component: AttendanceViewComponent,
		canActivate: [AuthguardService],
	},
];
